import api from './api';

const institutionalService = {
  async get() {
    const response = await api.get('/institutional-info');
    return response.data;
  },

  async update(data) {
    const response = await api.put('/institutional-info', data);
    return response.data;
  },
};

export default institutionalService;
